import React from 'react';
import PropTypes from 'prop-types';
import { Bert } from 'meteor/themeteorchef:bert';
import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';

import { isEqual, map, indexOf, cloneDeep, find, isEmpty } from 'lodash';
import { Button, Alert, Stack, Tooltip, IconButton } from '@mui/material';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import methodPromise from '../../../modules/method-promise-wrapper';
import handleErrorInClient from '../../../modules/handle-error-in-client';

import Sources from '../../../api/Sources/Sources';
import Connectors from '../../../api/Connectors/Connectors';
import ConfigurationsConnectors from '../../../api/ConfigurationsConnectors/ConfigurationsConnectors';
import AnnotationTemplates, {
  LIBRARY_ICON_TYPES,
  ELEMENT_TYPES
} from '../../../api/AnnotationTemplates/AnnotationTemplates';
import * as templateOps from '../../../api/AnnotationTemplates/annotation-template-operations';
import * as annotationOps from '../../../api/Annotations/annotation-operations';
import * as videoOps from '../../../api/Videos/video-operations';
import * as videoCalculate from '../../../api/Videos/videos-calculations';
import * as configOps from '../../../api/ConfigurationsConnectors/configurations-connectors-operations';
import * as sourceOps from '../../../api/Sources/source-operations';
import * as conenctorOps from '../../../api/Connectors/connector-operations';

import ViewAnnotationTemplate from '../../pages/ViewAnnotationTemplate/index';

import { VIDEO_COORDINATE_DATA_TYPES } from '../../../api/Videos/Videos';
import { renderSwitch } from '../MaterialMUIComponent';
import useTimeStore from '../ZustandProvider/index';

const AnnotationMapsEditor = props => {
  const {
    annotations,
    annotationTemplates,
    handleClose,
    handleNewAnnotations,
    sizePlayer,
    selectedAnnotation,
    videoSelected,
    isPublicMap,
    isUpdateEditor,
    configConnectorsList,
    annotationTemplatesCustom,
    sourcesList,
    connectorList,
    userProps,
    MapProps,
    ...rest
  } = props;

  const coordOnMap = useTimeStore(state => state.coordOnMap);
  const showNotesOnMap = useTimeStore(state => state.showNotesOnMap);

  const [isBaseTemplate, setIsBaseTemplate] = React.useState(true);
  const templatesToRender =
    isBaseTemplate || isEmpty(annotationTemplatesCustom)
      ? annotationTemplates
      : annotationTemplatesCustom;

  const startAnnotation = !isUpdateEditor ? {} : selectedAnnotation;
  const startTemplate = !isUpdateEditor ? {} : annotationOps.getTemplate(selectedAnnotation);
  const [selectedTemplate, setSelectedTemplate] = React.useState(startTemplate);
  const [newAnnotation, setNewAnnotation] = React.useState(startAnnotation);
  const [newTimeAnnotation, setNewTimeAnnotation] = React.useState(0);

  const [manyNewAnnotation, setManyNewAnnotation] = React.useState([]);
  const configSelected = find(configConnectorsList, item =>
    isEqual(configOps.getTemplateId(item), templateOps.getId(selectedTemplate))
  );
  const sourceSelected = find(sourcesList, item =>
    isEqual(configOps.getSource(configSelected || {}), sourceOps.getId(item || {}))
  );
  const connectorSelected = find(connectorList, item =>
    isEqual(configOps.getConnectorId(configSelected || {}), conenctorOps.getId(item || {}))
  );
  const showSaveDB =
    !isEmpty(selectedTemplate) &&
    !isEmpty(configSelected) &&
    !isEmpty(connectorSelected) &&
    !isEmpty(sourceSelected);

  const [address, setAddress] = React.useState({});

  const addDependDataType = (element, value) => {
    if (element.dataType && value) {
      if (element.dataType === 'text' && typeof value !== 'string') {
        return value.toString();
      }
      if (element.dataType === 'number' && typeof value !== 'number') {
        return parseInt(value, 10);
      }
    } else {
      return value;
    }
    return value;
  };

  const coordinatesAddress = async coordinates => {
    if (!isEmpty(coordinates)) {
      try {
        const response = await fetch(
          'https://sd1.ipsgeoprocesing.ipsilum.com/MG/geolocation/exec_geocodificacion',
          {
            method: 'POST',
            body: JSON.stringify({
              point: coordinates
            }),
            headers: { 'Content-Type': 'application/json' },
            mode: 'cors',
            credentials: 'omit',
            referrerPolicy: 'no-referrer'
          }
        );
        const respuesta = await response.json();
        if (respuesta) {
          setAddress(respuesta);
          return respuesta;
        }
        setAddress('');
        return '';
      } catch (error) {
        console.error('Error al obtener la dirección:', error);
        return '';
      }
    }
    return '';
  };

  const fechaAGpsEnMicrosegundos = () => {
    const fechaConHora = new Date();
    const fechaReferenciaGps = new Date('1980-01-06T00:00:00Z');
    const diferencia = fechaConHora.getTime() - fechaReferenciaGps.getTime();
    const diferenciaEnMicroSegundos = diferencia * 1000;
    return diferenciaEnMicroSegundos;
  };

  const obtenerTiempoGpsEnDiasYHora = () => {
    const fechaConHora = new Date();
    const fechaReferenciaGps = new Date('1980-01-06T00:00:00Z');
    const diferenciaMilisegundos = fechaConHora.getTime() - fechaReferenciaGps.getTime();
    const dias = Math.floor(diferenciaMilisegundos / (1000 * 60 * 60 * 24));
    const horasRestantesMilisegundos = diferenciaMilisegundos % (1000 * 60 * 60 * 24);
    const horas = Math.floor(horasRestantesMilisegundos / (1000 * 60 * 60));
    const minutos = Math.floor((horasRestantesMilisegundos % (1000 * 60 * 60)) / (1000 * 60));
    const segundos = Math.floor((horasRestantesMilisegundos % (1000 * 60)) / 1000);
    return `Días: ${dias}, Hora: ${horas}:${minutos
      .toString()
      .padStart(2, '0')}:${segundos.toString().padStart(2, '0')}`;
  };

  const templateConfigurationFunction = (template, addressProp, coordsProp) => {
    if (!isUpdateEditor) {
      let newTemplate = cloneDeep(template);
      if (templateOps.getIsBase(template)) {
        const customAsociated = find(annotationTemplatesCustom, item =>
          isEqual(templateOps.getTemplateBaseId(item), templateOps.getId(template))
        );
        if (!isEmpty(customAsociated)) newTemplate = cloneDeep(customAsociated);
      }
      const configConnector = find(configConnectorsList, item =>
        isEqual(configOps.getTemplateId(item), templateOps.getId(newTemplate))
      );
      const configFields = configOps.getConnectionsFields(configConnector || {});
      if (!isEmpty(configFields)) {
        newTemplate.elements = template.elements.map(element => {
          const matchingElement = cloneDeep(element);

          const matchingConfig = configFields.find(el => {
            return isEqual(configOps.getElementIndex(el), templateOps.getElementOrder(element));
          });
          if (!isEmpty(matchingElement) && !isEmpty(matchingConfig)) {
            if (matchingConfig.value === 'latitud') {
              matchingElement.value = addDependDataType(matchingElement, coordsProp[0]);
            } else if (matchingConfig.value === 'longitud') {
              matchingElement.value = addDependDataType(matchingElement, coordsProp[1]);
            } else if (matchingConfig.value === 'address') {
              matchingElement.value = addDependDataType(matchingElement, addressProp.address);
            } else if (matchingConfig.value === 'country') {
              matchingElement.value = addDependDataType(matchingElement, addressProp.country);
            } else if (matchingConfig.value === 'road') {
              matchingElement.value = addDependDataType(matchingElement, addressProp.road);
            } else if (matchingConfig.value === 'postcode') {
              matchingElement.value = addDependDataType(matchingElement, addressProp.postcode);
            } else if (matchingConfig.value === 'city') {
              matchingElement.value = addDependDataType(matchingElement, addressProp.city);
            }

            if (matchingConfig.value === 'userId') {
              const newUser = isEmpty(userProps.userId) ? MapProps.map.publicId : userProps.userId;
              matchingElement.value = addDependDataType(matchingElement, newUser);
            } else if (matchingConfig.value === 'userLocalId') {
              matchingElement.value = addDependDataType(matchingElement, userProps.userLocalId.id);
            } else if (matchingConfig.value === 'userLocalName') {
              matchingElement.value = addDependDataType(
                matchingElement,
                userProps.userLocalId.name
              );
            } else if (matchingConfig.value === 'mapId') {
              matchingElement.value = addDependDataType(matchingElement, MapProps.map._id);
            } else if (matchingConfig.value === 'fecha') {
              matchingElement.value = addDependDataType(
                matchingElement,
                new Date().toLocaleDateString()
              );
            } else if (matchingConfig.value === 'hora') {
              matchingElement.value = addDependDataType(
                matchingElement,
                new Date().toLocaleTimeString()
              );
            } else if (matchingConfig.value === 'tiempoGPS') {
              matchingElement.value = addDependDataType(
                matchingElement,
                fechaAGpsEnMicrosegundos()
              );
            } else if (matchingConfig.value === 'tiempoGPSView') {
              matchingElement.value = addDependDataType(
                matchingElement,
                obtenerTiempoGpsEnDiasYHora()
              );
            }
          }
          return matchingElement;
        });
      }
      return newTemplate;
    }
    return template;
  };

  const updateAnnotationFields = (elementItem, property, newValue) => {
    const newTemplate = cloneDeep(selectedTemplate);
    const annotation = cloneDeep(newAnnotation);
    const templateElementsArray = templateOps.getElements(selectedTemplate);
    const elementUpdate = find(templateElementsArray, element => isEqual(element, elementItem));
    const newElementTemplate = map(templateElementsArray, element => {
      const newElement = element;
      if (
        isEqual(
          indexOf(templateElementsArray, element),
          indexOf(templateElementsArray, elementUpdate)
        )
      ) {
        newElement[property] = newValue;
      }
      return newElement;
    });
    newTemplate.elements = newElementTemplate;
    annotation.geoJSON.properties.template = newTemplate;
    setSelectedTemplate(newTemplate);
    setNewAnnotation(annotation);
  };

  const handleSelectedTemplateChange = (templateSelect, isBase = true) => {
    const videoId = videoOps.getId(videoSelected);
    const annotationTemplateDefault = cloneDeep(templateSelect);
    if (isBase)
      annotationTemplateDefault.elements.forEach(item => {
        // eslint-disable-next-line no-param-reassign
        item.value = '';
      });

    const newTemplate = templateConfigurationFunction(annotationTemplateDefault, address, [
      coordOnMap.lat,
      coordOnMap.lng
    ]);
    const annotation = {
      geoJSON: {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: !isEmpty(coordOnMap) ? [coordOnMap.lng, coordOnMap.lat] : []
        },
        properties: {
          video: videoId,
          videoTime: newTimeAnnotation,
          videoPosition: sizePlayer,
          template: newTemplate,
          isProyected: !isEqual(
            VIDEO_COORDINATE_DATA_TYPES.POINT,
            videoOps.getCoordinatesDataType(videoSelected)
          )
        }
      },
      origin: 'manual'
    };

    setSelectedTemplate(newTemplate);
    setNewAnnotation(annotation);
    useTimeStore.setState({
      showNotesOnMap: {
        ...showNotesOnMap,
        methodEditor: 'create',
        enableCenter: false,
        annotations: [],
        selectAnnotation: {},
        videos: [videoSelected],
        selectVideo: videoSelected
      }
    });
  };

  const postDataConnection = async (connection, sourceTableName, data) => {
    const { user, databaseName, ip, port, password, schema } = connection;
    const serverToConnection = {
      user,
      ip,
      port,
      databaseName,
      password,
      schema,
      tableName: sourceTableName
    };
    try {
      const response = await fetch(
        'https://sd1.ipsgeoprocesing.ipsilum.com/MG/utilities/upload_to_database',
        {
          method: 'POST',
          body: JSON.stringify({
            connection: serverToConnection,
            data
          }),
          headers: { 'Content-Type': 'application/json' }
        }
      );
      const answer = await response.json();
      if (typeof answer === 'string') {
        if (answer.includes('error')) {
          Bert.alert('There have been an error saving data in db ', 'danger');
        } else {
          Bert.alert('Data saved succesfully', 'success');
        }
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  const uploadDataToDataBase = (templateSelect, configSelect, connectionSelect, sourceSelect) => {
    const sourceTableName = sourceOps.getLayerName(sourceSelect || {});
    // data: { [nameColumnTable]: timeVideo }
    const newData = map(configOps.getConnectionsFields(configSelect), config => {
      const elementTemplate = find(templateOps.getElements(templateSelect), el =>
        isEqual(templateOps.getElementOrder(el), configOps.getElementAsociatedIndex(config))
      );
      let valueToSave = templateOps.getElementValue(elementTemplate);
      if (isEqual(configOps.getValue(config), 'labelName'))
        valueToSave = templateOps.getElementLabelName(elementTemplate);
      if (isEqual(configOps.getValue(config), 'hiperLink'))
        valueToSave = templateOps.getElementHiperLink(elementTemplate);
      return { [configOps.getNameField(config)]: valueToSave };
    });
    if (!isEmpty(connectionSelect) && !isEmpty(sourceTableName) && !isEmpty(newData))
      postDataConnection(connectionSelect, sourceTableName, newData);
  };

  const handleSubmit = async () => {
    const videoId = videoOps.getId(videoSelected);
    try {
      const newAnnotations = manyNewAnnotation.map(element => {
        const newObject = {
          geoJSON: {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [element.newCoords.lng, element.newCoords.lat]
            },
            properties: {
              video: videoId,
              videoTime: element.newTime,
              videoPosition: sizePlayer,
              template: element.templateProp,
              isProyected: true
            }
          },
          origin: 'manual'
        };
        return newObject;
      });
      if (!isEmpty(newAnnotation) && isUpdateEditor) {
        delete newAnnotation.createdAt;
        delete newAnnotation.updatedAt;
        delete newAnnotation.owner;
      }
      const methodCall = !isUpdateEditor ? 'annotations.insertMany' : 'annotations.update';
      const annotationsToSave = !isUpdateEditor ? newAnnotations : newAnnotation;
      const newIdAnnotation = await methodPromise(methodCall, annotationsToSave, isPublicMap);
      if (isEqual(methodCall, 'annotations.insertMany')) handleNewAnnotations(newIdAnnotation);
      const textAlert = !isUpdateEditor ? 'Annotation created' : 'Annotation updated';
      Bert.alert(textAlert, 'success');
      handleClose();
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  React.useEffect(() => {
    if (!isEmpty(showNotesOnMap.proyectedPoint)) {
      const time = videoCalculate.calculateTimeVideoLine(
        videoSelected,
        showNotesOnMap.proyectedPoint,
        annotations
      );
      setNewTimeAnnotation(time);
    } else {
      const time = videoCalculate.calculateTimeVideoPoint(annotations, manyNewAnnotation);
      setNewTimeAnnotation(time);
    }
  }, [showNotesOnMap.proyectedPoint]);

  React.useEffect(() => {
    if (!isEmpty(coordOnMap) && !isEmpty(newAnnotation)) {
      const newTemplate = cloneDeep(annotationOps.getTemplate(newAnnotation));
      newTemplate.elements = map(newTemplate.elements, el => {
        const newEl = cloneDeep(el);
        if (isEqual(templateOps.getElementType(newEl), ELEMENT_TYPES.IMAPS)) {
          const mapEl = templateOps.getElementMap(newEl);
          if (!isEmpty(mapEl)) {
            if (isEqual(mapEl.centerMode, 'Annotation'))
              mapEl.coordsCenter = [coordOnMap.lat, coordOnMap.lng];
            newEl.map = cloneDeep(mapEl);
          }
        }
        if (isEqual(templateOps.getElementType(newEl), ELEMENT_TYPES.MULTIPLEIMAPS)) {
          const multiMapsEl = templateOps.getElementMultipleMaps(newEl);
          if (!isEmpty(multiMapsEl)) {
            const newMultiMapsEl = map(multiMapsEl, multiEl => {
              const cloneMultiEl = cloneDeep(multiEl);
              if (isEqual(cloneMultiEl.centerMode, 'Annotation'))
                cloneMultiEl.coordsCenter = [coordOnMap.lat, coordOnMap.lng];
              return cloneMultiEl;
            });
            newEl.multipleMaps = cloneDeep(newMultiMapsEl);
          }
        }

        return newEl;
      });

      const coordinates = [coordOnMap.lat, coordOnMap.lng];
      const newAddres = coordinatesAddress(coordinates);
      const newTemplateConfig = templateConfigurationFunction(newTemplate, newAddres, coordinates);
      const annotation = {
        geoJSON: {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [coordOnMap.lng, coordOnMap.lat]
          },
          properties: {
            ...newAnnotation.geoJSON.properties,
            template: newTemplateConfig
          }
        },
        origin: 'manual'
      };
      setSelectedTemplate(newTemplateConfig);
      setNewAnnotation(annotation);
    }
  }, [coordOnMap]);

  React.useEffect(() => {
    if (!isEmpty(address)) {
      const coordinates = [coordOnMap.lat, coordOnMap.lng];
      const newTemplateConfig = templateConfigurationFunction(
        selectedTemplate,
        address,
        coordinates
      );
      const annotation = {
        geoJSON: {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [coordOnMap.lng, coordOnMap.lat]
          },
          properties: {
            ...newAnnotation.geoJSON.properties,
            template: newTemplateConfig
          }
        },
        origin: 'manual'
      };
      setSelectedTemplate(newTemplateConfig);
      setNewAnnotation(annotation);
    }
  }, [address]);

  return (
    <>
      {!isUpdateEditor && (
        <Stack direction="row" display="flex" justifyContent="center">
          {!isEmpty(annotationTemplatesCustom) &&
            renderSwitch({
              key: 'option-templates',
              checked: isBaseTemplate,
              disabled: false,
              onChange: event => {
                setIsBaseTemplate(event.target.checked);
                if (isEqual(event.target.checked, false)) {
                  handleSelectedTemplateChange(annotationTemplatesCustom[0], false);
                } else {
                  handleSelectedTemplateChange(annotationTemplates[0]);
                }
              },
              labelCheck: 'View base templates',
              labelUncheck: 'View custom templates',
              styleLabel: { margin: 0 }
            })}
        </Stack>
      )}
      {map(templatesToRender, (template, index) => {
        const libraryIcons = templateOps.getLibraryIcon(template);
        const buttonStyle = isEqual(
          templateOps.getId(template),
          templateOps.getId(selectedTemplate)
        )
          ? 'success'
          : 'primary';
        return (
          <Button
            key={`${templateOps.getName(template)}-${index}`}
            color={buttonStyle}
            variant="outlined"
            onClick={() => {
              handleSelectedTemplateChange(template);
            }}
          >
            {libraryIcons === LIBRARY_ICON_TYPES.FONTAWESOME && (
              <FontAwesomeIcon icon={templateOps.getIcon(template)} size="lg" />
            )}
            {libraryIcons === LIBRARY_ICON_TYPES.SVG && (
              <img
                src={templateOps.getIconSvg(template)}
                alt={templateOps.getIcon(template)}
                style={{ marginRight: '5px', width: '20px', height: '20px' }}
              />
            )}
          </Button>
        );
      })}
      {!isUpdateEditor && (
        <Stack direction="row" display="flex" justifyContent="center" width="100%">
          <Alert variant="info">{`${manyNewAnnotation.length} annotations added`}</Alert>
          <Tooltip title="Add annotation" placement="top-start">
            <span>
              <IconButton
                disabled={isEmpty(newAnnotation) || isEmpty(coordOnMap)}
                aria-label="comments"
                onClick={() => {
                  setManyNewAnnotation(prevAnnotation => [
                    ...prevAnnotation,
                    {
                      newCoords: coordOnMap,
                      newTime: newTimeAnnotation,
                      templateProp: annotationOps.getTemplate(newAnnotation)
                    }
                  ]);
                  useTimeStore.setState({
                    showNotesOnMap: { ...showNotesOnMap, updateMap: !showNotesOnMap.updateMap }
                  });
                }}
              >
                <NoteAddIcon style={{ color: 'blue' }} />
              </IconButton>
            </span>
          </Tooltip>
        </Stack>
      )}

      <ViewAnnotationTemplate
        selectedTemplate={templateOps.getId(selectedTemplate)}
        annotationTemplate={annotationOps.getTemplate(newAnnotation)}
        updateAnnotationFields={updateAnnotationFields}
        updateAnnotationSelected={annotation => setNewAnnotation(annotation)}
        updatedAnnotation={newAnnotation}
        video={videoSelected}
        readOnly
        isShowButtons={false}
        startingPreviewMode="edition"
        envSettings="NotesComponent"
        isNotesComponent
        {...rest}
      />
      <Stack direction="row" display="flex" justifyContent="flex-end">
        <Button
          size="small"
          variant="outlined"
          color="primary"
          onClick={() => {
            handleClose();
          }}
        >
          Back
        </Button>
        {showSaveDB && (
          <Button
            size="small"
            variant="outlined"
            color="success"
            disabled={false}
            onClick={() =>
              uploadDataToDataBase(
                selectedTemplate,
                configSelected,
                connectorSelected,
                sourceSelected
              )
            }
          >
            Save in DB
          </Button>
        )}
        <Button
          size="small"
          variant="outlined"
          color="success"
          disabled={isEmpty(manyNewAnnotation) && !isUpdateEditor}
          onClick={() => handleSubmit()}
        >
          {!isUpdateEditor ? 'Finish' : 'Update'}
        </Button>
      </Stack>
    </>
  );
};

AnnotationMapsEditor.defaultProps = {
  sizePlayer: { x: 0, y: 0, width: 0, height: 0 },
  isPublicMap: false,
  selectedAnnotation: {},
  handleNewAnnotations: () => {},
  configConnectorsList: [],
  annotationTemplatesCustom: [],
  sourcesList: [],
  connectorList: [],
  userProps: {},
  MapProps: {}
};

AnnotationMapsEditor.propTypes = {
  isUpdateEditor: PropTypes.bool.isRequired,
  annotations: PropTypes.array.isRequired,
  annotationTemplates: PropTypes.array.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleNewAnnotations: PropTypes.func,
  sizePlayer: PropTypes.object,
  selectedAnnotation: PropTypes.object,
  videoSelected: PropTypes.object.isRequired,
  isPublicMap: PropTypes.bool,
  configConnectorsList: PropTypes.array,
  annotationTemplatesCustom: PropTypes.array,
  sourcesList: PropTypes.array,
  connectorList: PropTypes.array,
  userProps: PropTypes.object,
  MapProps: PropTypes.object
};

export default withTracker(({ videoSelected }) => {
  const configConnectorsVideosSub = Meteor.subscribe('configConnector.customTemplates.videos', [
    videoOps.getId(videoSelected)
  ]);
  const configConnectorsList = ConfigurationsConnectors.find({}, { sort: { name: 1 } }).fetch();
  const annotationTemplatesCustom = AnnotationTemplates.find({}, { sort: { name: 1 } }).fetch();
  const sourcesList = Sources.find({}, { sort: { name: 1 } }).fetch();
  const connectorList = Connectors.find({}, { sort: { name: 1 } }).fetch();
  return {
    loading: !configConnectorsVideosSub.ready(),
    configConnectorsList,
    annotationTemplatesCustom,
    sourcesList,
    connectorList
  };
})(AnnotationMapsEditor);
